import React, { useEffect, useState } from 'react'
import PageTitleDes from '../../../core/support/PageTitleDes'
import socketIOClient from 'socket.io-client'
import Config from '../../../core/config'
import { makeRequest } from '../../../core/services/v1/request'
import { useContextData } from '../../../core/context'
import '../../../assets/style.css'
import { useNavigate } from 'react-router-dom'
import { toast } from '../../../core/lib/toastAlert'
import Loader from '../../../Component/Loader/Loader'
import { Helmet } from 'react-helmet-async'
import '../../../Component/SignalView/signalView.css'
import PnlCards from '../../../Component/SignalView/components/PnlCards'
import SignalsTable from '../../../Component/SignalView/components/SignalsTable'

const SignalView = () => {
  const navigate = useNavigate()
  const [value, setValue] = useState(0)
  const [coins, setCoins] = useState({ USDT: [], INR: [] })
  const [futuresCoin, setFuturesCoin] = useState([])
  const [socketConnection, setSocketConnection] = useState(null)
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])
  const [closedData, setClosedData] = useState([])
  const [utiLoading, setUTILoading] = useState(false)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)

  const { coindcxDecimal, spotPnl, myProfile, profileLoading } =
    useContextData()
  const handleChange = (newValue) => {
    setValue(() => newValue)
  }
  const getUTIBalance = async () => {
    try {
      const params = {
        url: `${Config.V2_API_URL}wallet/getUNITICBalance`,
        method: 'GET'
      }
      const response = await makeRequest(params)
      if (response) {
        const actual =
          (response?.data?.amount || 0) + (response?.data?.hold || 0)
        if (actual < 1000) {
          toast({
            type: 'error',
            message: 'Hold 1000 UNITIC Tokens to Access Signals'
          })
          navigate('/my/dashboard')
        }
      }
      setUTILoading(() => false)
    } catch (e) {
      setUTILoading(() => false)
    }
  }
  useEffect(() => {
    // getUTIBalance()
    // setUTILoading(() => false)
    if (
      !utiLoading &&
      !profileLoading &&
      ((myProfile.additionalKyc.status !== 'manually_approved' &&
        myProfile.additionalBank.status !== 'manually_approved' &&
        myProfile.additionalKyc.status !== 'auto_approved' &&
        myProfile.additionalKyc.status !== 'approved' &&
        myProfile.additionalBank.status !== 'auto_approved' &&
        myProfile.additionalBank.status !== 'approved') ||
        myProfile?.kycOffline?.aadhaar?.status != 1 ||
        myProfile?.kycOffline?.aml?.status != 1 ||
        myProfile?.kycOffline?.identity?.status != 1)
    ) {
      toast({
        type: 'error',
        message: 'Please complete your KYC to continue.'
      })
      navigate('/my/identification')
    }
  }, [myProfile, profileLoading, utiLoading])

  const getSignalData = async () => {
    const getURL = Config.V1_API_URL + 'spot-signal/get-active-spot-signal'
    const params = {
      url: getURL,
      method: 'GET'
    }
    const submit = await makeRequest(params)
    if (submit.success) {
      setData(() => submit?.data)
    }
  }
  const getSignalData2 = async () => {
    const getURL =
      Config.V1_API_URL + 'futures-signal/get-active-futures-signal'
    const params = {
      url: getURL,
      method: 'GET'
    }
    const submit = await makeRequest(params)
    if (submit.success) {
      setData2(() => submit?.data)
    }
  }
  const getSignalClosedData = async (page = 1) => {
    const params = {
      url: Config.V1_API_URL + 'spot-signal/get-result-spot-signal?page=' + page + '&limit=10',
      method: 'GET'
    }

    const submit = await makeRequest(params)

    if (submit.success) {
      setClosedData(() => submit.data)
      // setTotal(submit.total || 0)
      setTotalPages(() => Math.ceil((submit.total || 0) / 10))
    }
  }
  const getSmartPagination = (current, total) => {
    const delta = 2;
    const pages = [];

    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    if (right < total - 1) {
      pages.push("...");
    }

    if (total > 1) {
      pages.push(total);
    }

    return pages;
  };
  const getCoins = async () => {
    const params = {
      url: `${Config.V1_API_URL}trade/getMarketsTab?exchangeType=SPOT`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response.status && response.data) {
      const getInr = response.data.find(data => data?.currency === 'INR')
      const getUsdt = response.data.find(data => data?.currency === 'V2USDT')
      setCoins(() => ({
        USDT: getUsdt?.pairs,
        INR: getInr?.pairs
      }))
    }
  }
  const getFuturesCoins = async () => {
    const params = {
      url: `${Config.V1_API_URL}futures-signal/get-futures-prices`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response.status && response.data) {
      setFuturesCoin(() => response.data)
    }
  }
  useEffect(() => {
    getSignalData()
    getSignalData2()
    getSignalClosedData()
    getCoins()
    // getFuturesCoins()
    let socket = socketIOClient(Config.SOCKET_URL, {
      // transports: ["polling"],
      transports: ['websocket']
      // rejectUnauthorized: false
    })
    let socketUnsubscribe
    if (socket) {
      socket.on('connect', function () {
        setSocketConnection(socket)
        socketUnsubscribe = socket
      })
      socket.on('connect_error', err => {
        console.log('socket connect_error', err)
      })
      socket.on('disconnect', function () { })
    }
    return () => {
      if (socketUnsubscribe) {
        socketUnsubscribe.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    if (socketConnection != null) {
      // loadSocket()
    }
  }, [socketConnection])

  function loadSocket() {
    socketConnection.emit('getActiveSpotSignals', {})
    socketConnection.emit('getClosedSpotSignals', {})
    socketConnection.emit('getMarketSpotSignals', {})
    socketConnection.on('get-active-spot-signal', function (data) {
      setData(() => data)
    })
    socketConnection.on('get-closed-spot-signal', function (data) {
      setClosedData(() => data)
    })
    socketConnection.on('get-market-spot-signal', function (data) {
      const getInr = data.find(data => data?.currency === 'INR')
      const getUsdt = data.find(data => data?.currency === 'USDT')
      setCoins(() => ({
        USDT: getUsdt?.pairs,
        INR: getInr?.pairs
      }))
    })
  }
  const percentageFunc = (tp, ep) => {
    return Math.abs(((tp - ep) / ep) * 100).toFixed(2)
  }
  const percentageFuturesLongFunc = (price, ePrice, leverage) => {
    ePrice = parseFloat(ePrice)
    price = parseFloat(price)
    leverage = parseFloat(leverage)
    if (!ePrice || !price || !leverage) {
      return 0.0
    }
    const getNetProfitValue = ((price - ePrice) / ePrice) * 100 * leverage
    return getNetProfitValue.toFixed(2) || 0.0
  }
  const percentageFuturesShortFunc = (price, ePrice, leverage) => {
    ePrice = parseFloat(ePrice)
    price = parseFloat(price)
    leverage = parseFloat(leverage)
    if (!ePrice || !price || !leverage) {
      return 0.0
    }
    const getNetProfitValue = ((-price - -ePrice) / ePrice) * 100 * leverage
    return getNetProfitValue.toFixed(2) || 0.0
  }
  if (profileLoading || utiLoading) {
    return <Loader />
  }
  return (
    <div className="bg-background signalView-theme" style={{ minHeight: 'calc(96vh - 50px)' }}>
      <PageTitleDes
        title={`Buy Bitcoin & Cryptocoin in India at the best price on UniticExchange`}
        description={`Buy BTC to INR, UTI Coin & Other Cryptocoin in India at the price on uniticexchange`}
      />
      <Helmet>
        <link rel='canonical' href='https://uniticexchange.com/signal' />
      </Helmet>
      <div className="d-flex">
        <main className="flex-fill p-4 pt-2 overflow-auto pb-2">
          <div className="mb-4 d-flex justify-content-between flex-column flex-md-row align-items-start align-items-lg-start gap-4">
            <div>
              <div className="d-flex align-items-center gap-2 mb-3">
                <span
                  className="rounded-circle signalView-bg-primary"
                  style={{ width: "8px", height: "8px" }}
                ></span>

                <span className="text-muted-foreground signalHeroSubTitle">
                  Trusted by{" "}
                  <span className="text-foreground fw-medium">
                    professional traders worldwide
                  </span>
                </span>
              </div>

              <h1 className="fw-bold text-foreground signalHeroTitle">
                Smart Crypto <span className="signalView-text-primary">Signals.</span>
              </h1>

              <p className="signalView-text-muted-foreground mt-2 signalHeroSubTitle">
                Real-time entries, smart targets, and proven results.
              </p>

              {/* Tabs */}
              <div className="d-flex align-items-center gap-2 mt-4">
                {["Spot", "Futures", "All Results"].map((tab, i) => (
                  <button
                    key={tab}
                    onClick={() => handleChange(i)}
                    className={`rounded-pill px-3 py-1 transition-colors ${value === i
                      ? "signalView-active text-white"
                      : "signalView-filter-btn border-border"
                      }`}
                    style={{ fontSize: "14px" }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
            <div className="signal-hero-img">
              <img src="/assets/signals-hero.png" alt="signal-hero" className="img-fluid" style={{
                objectFit: 'contain',
                // opacity: 0.8 
              }} width={250} />
            </div>
          </div>

          <div className="mb-5">
            <PnlCards pnlData={spotPnl} />
          </div>

          <SignalsTable value={value} data={data} data2={data2} closedData={closedData} coins={coins} percentageFunc={percentageFunc} percentageFuturesLongFunc={percentageFuturesLongFunc} percentageFuturesShortFunc={percentageFuturesShortFunc} coindcxDecimal={coindcxDecimal} getSignalClosedData={getSignalClosedData} page={page} setPage={setPage} totalPages={totalPages} getSmartPagination={getSmartPagination} />
        </main>
      </div>
    </div>
  );
};

export default SignalView;
